import Vue from 'vue';
import ElementUI from 'element-ui';

// import i18n from './../locale';

import 'element-ui/lib/theme-chalk/index.css';
import './../styl/variables.styl';
import './../styl/ui.styl';

Vue.use(ElementUI);